import { ThemeOptions } from '@mui/material/styles';

/**
 * Dark Theme Color Palette
 * Designed for comfortable viewing in low-light environments
 */
export const darkThemeOptions: ThemeOptions = {
  palette: {
    mode: 'dark',
    primary: {
      main: '#0a5266',
      light: '#0f7088',
      dark: '#052838',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#4db6ac',
      light: '#80cbc4',
      dark: '#00897b',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    error: {
      main: '#f44336',
      light: '#e57373',
      dark: '#d32f2f',
    },
    warning: {
      main: '#ffa726',
      light: '#ffb74d',
      dark: '#f57c00',
    },
    info: {
      main: '#29b6f6',
      light: '#4fc3f7',
      dark: '#0288d1',
    },
    success: {
      main: '#66bb6a',
      light: '#81c784',
      dark: '#388e3c',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
      disabled: 'rgba(255, 255, 255, 0.5)',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    neutral: {
      200: '#1e293b',
      300: '#334155',
      400: '#475569',
      500: '#94a3b8',
      600: '#cbd5e1',
      900: '#f1f5f9',
    },
  },
};
